import { render } from "./i-multiselect.vue?vue&type=template&id=6f4f266c&scoped=true"
import script from "./i-multiselect.vue?vue&type=script&lang=js"
export * from "./i-multiselect.vue?vue&type=script&lang=js"

import "./i-multiselect.vue?vue&type=style&index=0&id=6f4f266c&lang=css"
import "./i-multiselect.vue?vue&type=style&index=1&id=6f4f266c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4f266c"]])

export default __exports__